import { useState, useEffect } from 'react';

import firebase from '../../firebase';

const auth = firebase.auth();

const store = { state: { firebaseUser: undefined, emailVerified: false }, listeners: [] };

auth.onAuthStateChanged((firebaseUser) => {
  store.state = { firebaseUser, emailVerified: !!firebaseUser?.emailVerified };
  store.listeners.forEach((_) => _(store.state));
});

const subscribe = (listener) => {
  store.listeners = [...store.listeners, listener];
  return () => {
    store.listeners = store.listeners.filter((_) => _ !== listener);
  };
};

export default function useFirebaseUser () {
  const [state, setState] = useState(store.state);
  useEffect(() => {
    setState(store.state);
    return subscribe(setState);
  }, []);
  const reloadEmailVerified = async () => {
    if (store.state.firebaseUser == null) return;
    await store.state.firebaseUser.reload();
    setState({ ...store.state, emailVerified: auth.currentUser.emailVerified });
  };

  return { firebaseUser: state.firebaseUser, emailVerified: state.emailVerified, reloadEmailVerified };
};
